import React, { useMemo } from "react";
import { getEchartTooltipString } from "@/pages/dashboard/components/EchartsTooltip";
import { getName } from "@home/utils/common";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import './index.scss';

const RevenueProgressTooltip = (props: any) => {
  const {
    data,
    isEn,
    nameHeader
  } = props || {};
  const columns = [
    {
      key: 'name',
      header: nameHeader,
    },
    {
      key: 'value',
      header: 'KPI%',
      align: 'right',
      render: (value: any, item: any) => (
        <div className="dbh-revenue-progress-tooltip-kpi">
          <div>{value || value === 0 ? `$${dataFormat({ value, formatRule: 'intBmk00' })}` : '-'}</div>
          <div>({value || value === 0 ? `${dataFormat({ value: item?.kpi, formatRule: 'percent2Decimal' })}` : '-'})</div>
        </div>
      )
    },
  ];

  const newData = useMemo(() => {
    const { value, kpi } = data;
    const numVal = Number(value);
    const numKpi = Number(kpi);
    let completedKpiPercent: string | number = '';
    let uncompletedValue: string | number = '';
    let uncompletedKpiPercent: string | number = '';
    if (value) {
      uncompletedValue = numVal > numKpi ? 0 : numKpi - numVal;
    }
    if (kpi) {
      completedKpiPercent = numVal / numKpi;
      uncompletedKpiPercent = completedKpiPercent > 1 ? 0 : 1 - completedKpiPercent;
    }
    const list = [
      {
        name: getName(isEn, 'Completed', '已完成'),
        value,
        kpi: completedKpiPercent
      },
      {
        name: getName(isEn, 'Uncompleted', '未完成'),
        value: uncompletedValue,
        kpi: uncompletedKpiPercent,
      }
    ];
    return list;
  }, [data, isEn]);
  const domString = getEchartTooltipString({
    table: {
      columns,
      data: newData
    }
  });

  return <div dangerouslySetInnerHTML={{ __html: domString }}></div>;
};
export default RevenueProgressTooltip;